module.exports = __webpack_public_path__ + "assets/img/comfitm-btn-bg-2f6229b4.png";